import { useMemo } from 'react';

import { useInboxes } from './use-inboxes';
import { type IInbox } from './types';
import { INITIAL_FILTERS } from './constants';

export const TEAM_INBOX_ID = -1;

export const DEFAULT_INBOX_ID = 'default';

/** Maps URL path IDs (string) to numeric inbox IDs for virtual inboxes. */
export const VIRTUAL_INBOX_URL_MAP: Record<string, number> = {
    [DEFAULT_INBOX_ID]: TEAM_INBOX_ID,
};

/** Returns the URL path for navigating to an inbox. */
export const getInboxUrl = (inbox: IInbox): string => {
    if (inbox.id === TEAM_INBOX_ID) { return `/landlord/inner/inboxes/${DEFAULT_INBOX_ID}`; }
    return `/landlord/inner/inboxes/${inbox.id}`;
};

const TEAM_INBOX: IInbox = Object.freeze({
    id: TEAM_INBOX_ID,
    landlord_user_id: 0,
    name: 'Team Inbox',
    filters: INITIAL_FILTERS,
    is_private: false,
    is_virtual: true,
});

/**
 * Returns all inboxes: virtual inboxes (pinned at top) followed by server inboxes.
 * Returns undefined for data while loading, matching the shape of useInboxes().
 *
 * Virtual inboxes (Team Inbox) are always present regardless of server state.
 */
export const useAllInboxes = () => {
    const { data: serverInboxes, ...rest } = useInboxes();

    const data = useMemo(() => {
        if (serverInboxes === undefined) { return undefined; }
        return [TEAM_INBOX, ...serverInboxes];
    }, [serverInboxes]);

    return { data, ...rest };
};
